// extracted by mini-css-extract-plugin
export default {"discountPercentBadge":"DiscountBadge_discountPercentBadge__AED5p","discountIcon":"DiscountBadge_discountIcon__AQaRq","discountPercentText":"DiscountBadge_discountPercentText__kKnOt"};